/** Package type (DB only; not shown in UI after SIPS-122 10/13). 1=単品, 2=組み合わせ */
export const PACK_TYPE_SINGLE = 1;
export const PACK_TYPE_COMBINATION = 2;

/** Sentinel for list multi-select 未選択 (null businessType / deviceType). */
export const PACK_FILTER_UNSET = 0;

export const normalizePackType = (value: number | null | undefined): number =>
  value === PACK_TYPE_COMBINATION ? PACK_TYPE_COMBINATION : PACK_TYPE_SINGLE;

/** MCCSver labels for package master (Notion: MCCSII / MCCSIII / MCCS Type T). */
export const packMccsLabel: Record<number, string> = {
  2: 'MCCSII',
  3: 'MCCSIII',
  11: 'MCCS Type T'
};

export const packMccsOptions: { val: number | null; label: string }[] = [
  { val: null, label: '未選択' },
  { val: 2, label: 'MCCSII' },
  { val: 3, label: 'MCCSIII' },
  { val: 11, label: 'MCCS Type T' }
];

/** Optional int for 事業区分 / MCCSver — empty / NaN → null (DB INT safe). */
export const toOptionalInt = (
  value: number | string | null | undefined
): number | null => {
  if (value === null || value === undefined || value === '') return null;
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n) || !Number.isInteger(n)) return null;
  return n;
};

/**
 * Payload for create/update API.
 * packType is not edited in UI; keep existing value on edit/copy, default 1 on create.
 * 事業区分 / MCCSver are optional.
 */
export const classificationPayload = (form: {
  packType?: number | null;
  businessType?: number | string | null;
  deviceType?: number | string | null;
}) => ({
  packType: normalizePackType(form.packType ?? undefined),
  businessType: toOptionalInt(form.businessType),
  deviceType: toOptionalInt(form.deviceType)
});
